/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/** @jsx jsx */

import { css, jsx } from '@emotion/react'

import { EuiFlexItem, EuiFlexGroup, EuiIcon, EuiText, useEuiTheme } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import type { FunctionComponent } from 'react'

const DeploymentCompletedMessage: FunctionComponent = () => {
  const { euiTheme } = useEuiTheme()

  const deploymentActivityCompletedIconStyle = css`
    color: ${euiTheme.colors.vis.euiColorVis0};
    margin-top: ${euiTheme.size.s};
  `

  return (
    <EuiFlexGroup gutterSize='m' responsive={false}>
      <EuiFlexItem grow={false}>
        <EuiIcon css={deploymentActivityCompletedIconStyle} type='checkInCircleFilled' size='l' />
      </EuiFlexItem>

      <EuiFlexItem style={{ justifyContent: 'center' }} grow={false}>
        <EuiText size='s'>
          <p data-test-id='deployment-created'>
            <FormattedMessage
              id='deployment-activity.deployment-ready'
              defaultMessage='Your deployment is ready!'
            />
          </p>
        </EuiText>
      </EuiFlexItem>
    </EuiFlexGroup>
  )
}

export default DeploymentCompletedMessage
